/* src/components/LoadingSpinner.scss */
@import "../shared";

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1.2rem;
  margin-top: -1.2rem;
  border: 0.4rem solid #fff;
  border-top-color: transparent;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  &--red {
    border-color: transparent $red-border $red-border $red-border;
  }

  &--green {
    border-color: transparent $green-border $green-border $green-border;
  }

  &--blue {
    border-color: transparent $header-background $header-background $header-background;
  }

  &--small {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 1.2rem;
  }

  &--large {
    width: 4.8rem;
    height: 4.8rem;
    margin-left: -2.4rem;
    margin-top: -2.4rem;
    border-radius: 2.4rem;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
